import React, { useEffect, useState } from 'react';
import { sanitizeHeaderText } from '../../../utils/commonUtils';
import label from '../../../ui-constants/en.json';
import { IContent, IRelevantFiles } from '../../../models/IQueryType';
import { Guid } from 'guid-typescript';
import SORT_ARROW from '../../assets/sort_arrows.svg';
import LABELS from '../../../ui-constants/en.json';

import './TableTranscripts.scss';

type TableContentProps = {
  tableContent: Partial<IRelevantFiles>[];
};

const TranscriptTableContent = ({ tableContent }: TableContentProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showAllRecords, setShowAllRecords] = React.useState<boolean>(false);
  const [visibleRecords, setVisibleRecords] = React.useState<any>();
  const [sortingYear, setSortingYear] = React.useState<any>(null);
  let showData = false;
  const visibledata = () => {
    const sortedArray = tableContent?.sort(function (a, b) {
      const yearA = a.years && a.years.length > 0 ? parseInt(a.years[0]) : 0;
      const yearB = b.years && b.years.length > 0 ? parseInt(b.years[0]) : 0;
      return sortingYear ? yearA - yearB : yearB - yearA;
    });

    const calculatedData = sortedArray.filter((value: any) => {
      return value && (value.years?.length > 0 || value.sector?.length > 0);
    });

    if (!showAllRecords) {
      setVisibleRecords(calculatedData?.slice(0, 3));
    } else {
      setVisibleRecords(calculatedData);
    }
    showData = true;
  };

  useEffect(() => {
    visibledata();
  }, [showAllRecords, tableContent]);
  return (
    <div className='transcripttable' key={`key-${Guid.create()}`}>
      {visibleRecords && visibleRecords.length > 0 ? (
        <>
          <table className='transcripttable-table'>
            <tbody>
              <tr key={`table-header-${'transcripts'}`}>
                <th key={`table-header-${'years'}`} className='transcripttable__sort-col'>
                  {sanitizeHeaderText('Year(s)')}
                </th>
                <th key={`table-header-${'sectors'}`}>
                  {sanitizeHeaderText('Sector(s)')}
                </th>
              </tr>

              {visibleRecords?.map((value: any, i: number) => (
                <tr key={`table-row-${i}`}>
                  <td key={`table-data-years-${i}`}>
                    <div className='center-text'>
                      {Array.isArray(value?.years) && value.years.length > 0 
                        ? value.years.join(', ')
                        : '-'}
                    </div>
                  </td>

                  <td key={`table-data-sectors-${i}`}>
                    <div className='center-text'>
                      {Array.isArray(value?.sector) && value.sector.length > 0 
                        ? value.sector.join(', ')
                        : '-'}
                    </div>
                  </td>
                </tr>
              ))}

              {tableContent && tableContent?.length > 3 && (
                <tr key={`tableContent-row-${Guid.create()}`}>
                  <td colSpan={2} className='table__footer'>
                    <button
                      className='btn-show'
                      onClick={() => {
                        setShowAllRecords(!showAllRecords);
                      }}>
                      {showAllRecords ? '- See less' : '+ See more'}
                    </button>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </>
      ) : (
        <>{LABELS.chat_reply.SE_ERROR_MSG_ENGAGEMENT}</>
      )}
    </div>
  );
};

export default React.memo(TranscriptTableContent);
